import { AfterViewInit, ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormControl, FormGroupDirective, FormsModule } from '@angular/forms';
import { transformPrice } from '@app/core/price-utils';
import { MobilePhoneFormControls } from '@app/sales/modules/mobilephone/components/mobilephone-search/mobilephone-details/mobilephone-details.component';
import { OfferingHelperService } from '@app/sales/services/offering-helper.service';
import { ApiGetAllSubscriptionOfferingsAction } from '@app/sales/states/customer-product/customer-product.actions';
import { CustomerProductSelectors } from '@app/sales/states/customer-product/customer-product.selectors';
import { ApiGetOfferingsAction } from '@app/sales/states/offering/offering.actions';
import { IceSelectBoxComponent } from '@app/shared/components/molecules/ice-select-box/ice-select-box.component';
import {
  DoubleLineText,
  IceSelectComponent,
  Option,
} from '@app/shared/components/molecules/ice-select/ice-select.component';
import { PriceType } from '@app/shared/pipes/price-format.pipe';
import { select, Store } from '@ngxs/store';

@Component({
  selector: 'app-accessory-payment-details',
  templateUrl: './accessory-payment-details.component.html',
  imports: [IceSelectBoxComponent, IceSelectComponent, FormsModule],
})
export class AccessoryPaymentDetailsComponent implements AfterViewInit {
  private formGroupDirective = inject(FormGroupDirective);
  private store = inject(Store);
  private cdr = inject(ChangeDetectorRef);

  manualRegistrationOfferings = select(CustomerProductSelectors.getManualRegistrationOfferingsIncludingCustomerBTL);

  get offeringOptions(): Option[] {
    return this.manualRegistrationOfferings().map(offering => {
      const vasProduct = OfferingHelperService.getVasProductFromOffering(offering);
      const vasPriceText =
        vasProduct?.monthlyPrice?.price.includingVAT > 0
          ? `+ ${transformPrice(vasProduct.monthlyPrice.price.includingVAT, PriceType.OneTime)}`
          : 'Inkludert';
      const vasCombinedText = `${vasProduct?.productName} ${vasPriceText}`;

      return {
        displayName: {
          topLeftText: offering.name,
          topRightText: transformPrice(offering.monthlyPrice?.price, PriceType.Monthly),
          bottomLeftText: !!vasProduct ? vasCombinedText : '',
        } as DoubleLineText,
        value: offering.id,
      } as Option;
    });
  }

  get paymentMethodControl(): FormControl {
    return this.formGroupDirective.form?.controls.paymentMethod as FormControl;
  }
  get newSubscriptionIdControl(): FormControl {
    return this.formGroupDirective.form?.get(MobilePhoneFormControls.NewOfferingId) as FormControl;
  }

  ngAfterViewInit(): void {
    this.store.dispatch([new ApiGetOfferingsAction(), new ApiGetAllSubscriptionOfferingsAction()]);
    // This is to allow the select box to open on init
    if (this.manualRegistrationOfferings().length) this.cdr.detectChanges();
  }
}
